// React
import React, { useEffect, useState } from "react";
// Mui
import Grid from "@mui/material/Grid"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import s from "./Plantilla.module.css";
// Redux
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// Utils
import { dateFormats } from "../../../../helpers/convertDate";
import ConfigsSearcher from "../../../../config/Configs";
import { formatJavaCompletossx } from "../../../../config/strings";

// =========================== | PLANTILLA | ===================================

export const Plantilla = ({ data, assetsReady }) => {

  // Section: Utils Hooks
  const { t } = useTranslation();
  const dates = dateFormats();
  // Section: Reduc States
  const { textColor } = useSelector((state) => state.local);
  const { currentLogo } = useSelector((state) => state.local);
  const currentUser = useSelector((state) => state.gamma.logged_user);
  // Section: States
  const [logo, setLogo] = useState("");

  // Section: Effects
  useEffect(() => {
    setLogo(currentLogo.imgBase64);
  }, [currentLogo]);

  useEffect(() => {
    setTimeout(() => {
      assetsReady(true);
    }, 2000);
  }, []);

  // Section: Constants
  const config = ConfigsSearcher();
  const date = dates.formatLocalDate(data.dateCreate, formatJavaCompletossx);

  // Section: JSX
  return (
    <Grid container className={s.remito}>
      <Grid container item xs={12} className={s.canvas}>
        <Grid container item xs={12} className={s.header}>
          <Grid container item xs={5.25} className={s.imageContainer}>
            <Grid item xs={12} className={s.image}>
              <img src={logo} alt="userImage" />
              <span>{currentUser?.memberships[0]?.organization?.name}</span>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                mt: 1,
                mb: 2,
                ml: 3,
              }}
            >
              <p>
                {`${config.configFinder("ORG_DIR")} - ${config.configFinder("ORG_LOC")}` ||
                  ""}
              </p>
              <p>
                {`CP: ${config.configFinder("ORG_CP")} - Telefono: ${config.configFinder("ORG_TEL")}` ||
                  ""}
              </p>
              <p>{`Email: ${config.configFinder("ORG_EMAIL")}` || ""}</p>
            </Grid>
          </Grid>
          <Grid
            item
            xs={1.5}
            className={s.label}
            sx={{ backgroundColor: "primary.dark", color: textColor }}
          >
            OP
          </Grid>
          <Grid item xs={5.25} className={s.headerData}>
            <Grid
              item
              xs={12}
              className={s.title}
              sx={{
                backgroundColor: "primary.main",
                color: textColor,
                flexDirection: "column",
              }}
            >
              <p>{t("purchaseOrder").toUpperCase()}</p>
            </Grid>
            <Grid
              item
              xs={12}
              className={s.title2}
              sx={{ backgroundColor: "primary.light", color: textColor }}
            >
              <p>{`N° ${data?.id?.toString().padStart(5, "0")}`}</p>
            </Grid>
            <Grid item container xs={12} className={s.dates}>
              <Grid
                item
                xs={3}
                className={s.date}
                sx={{ backgroundColor: "primary.main", color: textColor }}
              >
                {t("date")}
              </Grid>
              <Grid item xs={8} className={s.box}>
                <p>{date}</p>
              </Grid>
            </Grid>
            <Grid item container xs={12} className={s.data}>
              <Grid item xs={12} sx={{ display: "flex" }}>
                <p>CUIT: {config.configFinder("ORG_CUIT") || ""}</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item xs={12} className={s.client}>
          <Grid
            item
            container
            xs={12}
            sx={{
              backgroundColor: "primary.main",
              color: textColor,
              padding: 2,
              justifyContent: "space-around",
            }}
          >
            <Grid item xs={2} sx={{ textAling: "center" }}>
              {t("provider")}:
            </Grid>
            <Grid item xs={3} sx={{ textAling: "center" }}>
              {data?.supplier?.businessName || ""}
            </Grid>
            <Grid item xs={3} sx={{ textAling: "center" }}>
              CUIT: {data?.supplier?.cuit}
            </Grid>
          </Grid>
          <Grid item container xs={10} className={s.dataClient} sx={{ m: 2 }}>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              Tel: +{data?.supplier?.phone}
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              {t("address")}:{" "}
              {`${data?.supplier?.address} ${data?.supplier?.numberAddress || ""} - ${data?.supplier?.location || ""}, ${data?.supplier?.province || ""}`}
            </Grid>
          </Grid>
        </Grid>

        <Grid container item xs={12} className={s.details}>
          <TableContainer className={s.tableContainer}>
            <Table>
              <TableHead sx={{ backgroundColor: "primary.light" }}>
                <TableRow>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("game")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("product")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: "18px",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("quantity")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.detailOrdersList?.map((item, i) => (
                  <React.Fragment key={i}>
                    <TableRow>
                      <TableCell>{item.game.name || ""}</TableCell>
                      <TableCell>
                        {item.raffle.number
                          ? `${t("drawNumber")}: ${item.raffle.number}`
                          : item.raffle.serie
                            ? `${t("serie")}: ${item.raffle.serie}`
                            : "-"}
                      </TableCell>
                      <TableCell width="15%">{item.amount}</TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        <Grid container item xs={12} className={s.observations}>
          <Grid item xs={11} className={s.text}>
            {`${t("observations")}: ${data.observations}`}
          </Grid>
          <Grid item xs={11} className={s.sign}>
            <p>{t("signature")} _______________________</p>
            <p>{t("clarification")} _______________________</p>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
